import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Pages, NavigationFunction as RootNavigation } from "../root";
import { colors, fonts, frames, glyphs, icons, useMediaQuery } from "../../Styles";
import { LogoDisplay, Overlay, MenuButton, StatusList } from "../../Components";
import { ButtonTypes, ListStyle_Types } from '../../Definitions';
import { SystemMenu } from "../Menus";
import { NewButtonList } from '../../Components/BaseComponents/newButton';
import { useAppSelector } from '../../Store';

export default function FocusViewPanelLayout() {
  const {t} = useTranslation()
  const location = useLocation();
  const navigator = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const farm = useAppSelector((state) => state.activeData.farm);

  const groupMenu2columns = useMediaQuery(`(max-width: 454px)`);
  const groupMenu3columns = useMediaQuery(`(min-width: 455px)`);

  const [showSystemMenu, setShowSystemMenu] = useState(false);
  const [showStatusBar, setShowStatusBar] = useState(false);
  
  const BtnFunc_Router = (btn_index: number) => {
    switch (btn_index) {
      case 0:
        RootNavigation({ Navigator: navigator, navigation_page: Pages.op_operations, currentDomain: farm})
        setShowStatusBar(false);
        setShowSystemMenu(false);
        break;
      case 1:
        setShowSystemMenu(true);
        setShowStatusBar(false);
        break;
      case 2:
        setShowStatusBar(true);
        setShowSystemMenu(false);
        break;
      case 3:
        RootNavigation({ Navigator: navigator, navigation_page: Pages.op_animals, currentDomain: farm})
        setShowStatusBar(false);
        setShowSystemMenu(false);
        break;
      case 4:
        RootNavigation({ Navigator: navigator, navigation_page: Pages.op_quickEntry, currentDomain: farm })
        setShowStatusBar(false);
        setShowSystemMenu(false);
        break;
      default:
        alert("Error")
    }
  };

  const toggleComponents = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return ( <>
    <MenuButton menuState={menuOpen} onClick={toggleComponents} focus_view/>

    <frames.focus_viewPanel>
      {menuOpen && createPortal ( <>
        <Overlay
          overrides={{
            zIndex: menuOpen ? 99999 : 0,
            blur: true
          }}
          content={
           <frames.Menu_Outer style={{ maxWidth: "555px", margin: "0 auto" }}>
              <div style={{gridArea: "1/1/2/2", overflow: "visible"}}><LogoDisplay focus_view ChooseSite selectedPage={Pages.op_operations} overrides={{borderRadius: (showSystemMenu||showStatusBar) ? "10px 10px 0px 0px" : "10px"}}/></div>

              <div style={{gridArea: "2/1/3/2", position: "relative", backgroundColor: (showSystemMenu||showStatusBar) ? colors.greyDarkPrimary : colors.transparent }}>
                {(showSystemMenu||showStatusBar) && <>
                  <div style={{ position: "absolute", right: "20px", top: "20px" }}><glyphs.Arrow rotate={-90} fillColor={colors.greyDarkSecondary} animate transition={2} /></div>
                  <div style={{ position: "absolute", right: "20px", bottom: "20px" }}><glyphs.Arrow rotate={90} fillColor={colors.greyDarkSecondary} animate transition={2} /></div>
                </>}
              </div>
              <frames.Menu_Inner $gridArea='2/1/3/2'>{showSystemMenu && <SystemMenu focus_view={true} />}</frames.Menu_Inner>
              <frames.Menu_Inner $gridArea='2/1/3/2'>{showStatusBar && <StatusList focus_view={true}/>}</frames.Menu_Inner>
              <div style={{gridArea: "3/1/4/2"}}>
                <div style={{width: "100%", height: "fit-content", maxWidth: "555px", padding: "7.5px 30px", boxSizing: "border-box", backgroundColor: colors.greyDarkPrimary, borderRadius: (showSystemMenu||showStatusBar) ? "0px 0px 10px 10px" : "10px", margin: "0px auto", display: "flex", justifyContent: "center"}}>
                  <div style={{}}>
                  <NewButtonList 
                    contents={[
                      t(`menuHeaders.${Pages.op_operations}`, {defaultValue: "operations"}), 
                      t("menuHeaders.systemMenu", {defaultValue: "system menu"}), 
                      t("menuHeaders.attentions", {defaultValue: "attentions"}), 
                      t(`menuHeaders.${Pages.animals}`, {defaultValue: "animals"}), 
                      t("menuHeaders.quickEntry", {defaultValue: "quick entry"})
                    ]}
                    onClick={(e) => BtnFunc_Router(e)}
                      buttonType={ButtonTypes.globalMenuButton}
                      disabled={[false, false, true, true, false]}
                      overrides={{
                        baseStyles: { width: groupMenu2columns ? "calc(50% - 2.5px)" : groupMenu3columns ? "calc(33.33% - 3.5px)" : "160px", height: "90px" },
                        contentStyles: { ...fonts.fontSize3},
                      startEnhancerStyles: {width: "35px", height: "35px"},
                        hoverStyles: { backgroundColor: colors.greyDarkSecondary },
                      disabledStyles: {opacity: "0.3"}
                    }}
                    listOverrides={{
                      listStyle: ListStyle_Types.group
                    }}
                    startEnhancers={[
                      icons.globalSettings, icons.globalSettings, icons.globalSettings, icons.globalSettings, icons.globalSettings
                    ]}/>
                  </div>
                </div>
              </div>
            </frames.Menu_Outer>
          }
        />
      </>, document.body )}
      <div style={{ gridArea: "page_outer", overflow: "hidden", height: "100%"}}>
        <Outlet /> 
      </div>
    </frames.focus_viewPanel>
  </> );
};